import React from 'react';
import CenterToast from './CenterToast';

const CenterToastContainer = ({ toasts, removeToast }) => {
  return (
    <>
      {toasts.map((t) => (
        <CenterToast
          key={t.id}
          message={t.message}
          actionLabel={t.actionLabel}
          onAction={t.onAction}
          duration={t.duration}
          onClose={() => removeToast(t.id)}
        />
      ))}
    </>
  );
};

export default CenterToastContainer;


